import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actionCreators } from "../redux/introConversionSagas";

export const UpdateButtons = () => {
  const dispatch = useDispatch();

  const { datesDirty, filtersDirty, currentUser } = useSelector((state) => {
    const { datesDirty, filtersDirty, currentUser } = state.introConversion;
    return { datesDirty, filtersDirty, currentUser };
  }, shallowEqual);
  const updateData = () => {
    if (filtersDirty && !datesDirty) {
      dispatch(actionCreators.fetchCurrentUser({ data: currentUser, updateFilters: true }));
    } else if (datesDirty) {
      dispatch(actionCreators.fetchDataAndFilters({ data: currentUser, noFilters: true }));
    }
  };

  const resetData = () => {
    dispatch(actionCreators.fetchCurrentUser({ data: currentUser, resetData: true }));
  };
  return filtersDirty || datesDirty ? (
    <>
      <button className="submit" onClick={updateData}>
        Update
      </button>

      <button className="submit reset" onClick={resetData}>
        Reset
      </button>
    </>
  ) : (
    ""
  );
};
